import React from 'react';
import Search from '../../containers/users/Search';
import Users from '../../containers/users/Users';

const Home = () => (
  <>
    <Search />
    <Users />
  </>
);

export default Home;
